module.exports = __webpack_public_path__ + "img/protection.686ca43c.svg";